/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const laboratoryServiceForms = sqliteTable('laboratory_service_forms', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  service_id: text('service_id'),
  form_definition_id: text('form_definition_id'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
